/**
 * Add a class to the document element if the scroll position isn't topped out.
 */

// A small element at the top of the page to watch
const el = document.createElement("div");
el.style.position = "absolute";
el.style.height = "1px";
el.style.zIndex = "-1000";
document.body.prepend(el);

// An observer to watch for its visibility
const observer = new IntersectionObserver(function (entries): void {
  for (const entry of entries) {
    if (entry.target !== el) continue;
    document.documentElement.classList.toggle(
      "is-scrolled",
      !entry.isIntersecting
    );
  }
});
observer.observe(el);
